<template>
  <div>
    <div v-for="(title, index) in headers" :key="index">
      <v-list-group
        prepend-icon="settings"
        value="true"
        v-if="
          menuItems.filter(
            (x) =>
              x.authGroups.includes(authGroup) &&
              x.menuItem.toLowerCase() == title.toLowerCase()
          ).length > 0
        "
      >
        <v-list-tile slot="activator">
          <v-list-tile-title>{{ title }}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          v-for="(item, i) in menuItems.filter(
            (x) => x.authGroups.includes(authGroup) && x.menuItem == title
          )"
          :key="i"
          @click="navigate(item.route)"
        >
          <v-list-tile-action>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-text="item.title"></v-list-tile-title>
        </v-list-tile>
      </v-list-group>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex';
const { mapGetters: mapAuthGetters } = createNamespacedHelpers(`orders/auth`);

export default {
  props: ['authGroup', 'menuItems', 'menuTitles'],
  data() {
    return {
      user: {},
      headers: [
        'Dealer',
        'Link',
        'Misc',
        'Qantas',
        'Hardware',
        'Kayako',
        'Maintain',
      ],
    };
  },
  computed: {
    ...mapAuthGetters(['auth']),
  },

  methods: {
    navigate: function (route) {
      this.$router.push(route);
    },
  },
};
</script>
